import axios from 'axios';
import config from '../config';
import keycloakService from './keycloak';

const api = axios.create({
  baseURL: config.apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include the auth token
api.interceptors.request.use(
  async (config) => {
    try {
      // Get the token
      const token = keycloakService.getToken();
      console.log('Token from Keycloak:', token); // Debug log
      
      // If token exists, add it to the headers
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
        console.log('Request headers:', config.headers); // Debug log
      } else {
        console.warn('No token available'); // Debug log
      }
      
      return config;
    } catch (error) {
      console.error('Error adding token to request:', error);
      return Promise.reject(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If the error is 401 and we haven't tried to refresh the token yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Try to refresh the token
        await keycloakService.updateToken();
        
        // Update the authorization header
        const newToken = keycloakService.getToken();
        console.log('New token after refresh:', newToken); // Debug log
        originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
        
        // Retry the original request
        return api(originalRequest);
      } catch (refreshError) {
        console.error('Token refresh failed:', refreshError); // Debug log
        // If refresh fails, redirect to login
        keycloakService.login();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api; 